import React from 'react';

import CRMApi from '../../../Api/CRM/CRMApi';
import BlockedCountry from '../../../Api/Models/BlockedCountry';
import { formatDateStringLong } from '../../../utils/formatters';
import ActionButton from '../../elements/ActionButton';
import DeleteButton from '../../elements/DeleteButton';
import Search from '../../elements/Search';
import Card from '../../elements/common/Card';
import SortButton from '../../elements/common/SortButton';
import TableHead from '../../elements/common/TableHead';
import TableLoader from '../../elements/common/TableLoader';
import Paginator from '../../elements/paginator';
import useAutoPaginator from '../../hooks/useAutoPaginator';
import {PERMISSION} from "../../helpers/Permissions";

const BlockedCountriesList = () => {
    const { items, updateItems, isLoading, auto } = useAutoPaginator<BlockedCountry>((page, params) =>
        CRMApi.blockedCountries.getAll(page, { params })
    );

    return (
        <>
            <ActionButton
                url="/blocked-countries/create"
                title="Add Country"
                permissions={[PERMISSION.CREATE_BLOCKED_COUNTRY]}
            />
            <Card title="Blocked countries">
                <TableLoader isLoading={isLoading}>
                    <Search {...auto.search} />
                    <table className="table model-list">
                        <TableHead>
                            <div />
                            <SortButton label="ISO Code" column="iso_code" {...auto.sort} />
                            <SortButton column="name" {...auto.sort} />
                            <SortButton label="Blocked since" column="created_at" {...auto.sort} />
                        </TableHead>
                        <tbody>
                            {items.map((item) => (
                                <tr key={item.id}>
                                    <td>
                                        <DeleteButton
                                            url={`/crea/api/blocked_countries/${item.id}`}
                                            action={updateItems}
                                            permissions={[PERMISSION.DELETE_BLOCKED_COUNTRY]}
                                        />
                                    </td>
                                    <td>{item.iso_code}</td>
                                    <td>{item.name}</td>
                                    <td>{formatDateStringLong(item.created_at)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <Paginator {...auto.paginator} />
                </TableLoader>
            </Card>
        </>
    );
};

export default BlockedCountriesList;
